export const getBlogTheTemp = (tempData: any) => {
    const tempData2 = JSON.parse(JSON.stringify(tempData || {}));
    const theTemp = tempData2?.theTemp || [];
    const theData = tempData2?.theData || {};
    let isFirstMainImg = true;
    for (let i = 0; i < theTemp.length; i++) {
        const tempItem = theTemp[i];
        const dataItem = theData[tempItem.id];
        if (!dataItem) {
            continue;
        }
        if (tempItem.name === 'BlogTitle' && dataItem.type === 'H1') {
            tempItem.__hide = true; //启动隐藏
        }
        if (tempItem.name === 'BlogImgVideo' && isFirstMainImg) {
            tempItem.__hide = true; //启动隐藏
            isFirstMainImg = false;
        }
    }

    return tempData2;
};
